import { RouterState, RouterStateModel } from '@ngxs/router-plugin';
import { Selector } from '@ngxs/store';

export class RouterSelectors {
  @Selector([RouterState])
  static isHomepage(router: RouterStateModel): boolean {
    const url = router.state?.url?.split('#')[0] || '';
    return url === '/';
  }

  @Selector([RouterState])
  static isGalleryPage(router: RouterStateModel): boolean {
    return router.state?.url.startsWith('/gallery') || false;
  }
}
